import * as React from 'react';

interface IProductItemWrapper {
    component: string;
    children: JSX.Element;
}

export const ProductItemWrapper = (props: IProductItemWrapper) => (
    <div className={`elc-product-item-wrapper elc-product-${props.component}-wrapper`}>
        {props.children}
    </div>
);
